export const GetStorageItem = (keyName, val) => {
    try {
        return ((localStorage.getItem(keyName) === val) ? true : false);
    } catch (event) {
        // Do nothing...;
    }
};

export const SetStorageItem = (keyName, val) => {
    try {
        return (localStorage.setItem(keyName, val) ? true : false);
    } catch (event) {
        // Do nothing...;
    }
};
